import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ListComponent from './ListComponent';
import { getDropdowns } from './utils';
import { createReqObj, responseListKeyMapping, searchInputOptions } from './constant';
import AMultiFieldSearchInput from 'components/AMultiFieldSearchInput/AMultiFieldSearchInput';
import { processRowList } from 'views/pages/manage/businessArea/component/FirstForm/constant';
import { endpoint, pages } from "../../../views/pages/manage/common/constant";
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { fetchDeletePromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { getAuditDetails } from 'views/pages/manage/businessArea/component/FirstForm/common';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';

const MappingListing = ({ selectedTab, setRowForm, rowForm }) => {
    const [rows, setRows] = useState([])
    const ref = useRef()
    const [dropdowns, setDropdowns] = useState({})
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [currPageSize, setCurrentPageSize] = useState(50)
    const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["userMappings"]["id"]
    );

    useEffect(() => {
        selectedTab?.key && init()
    }, [selectedTab?.key])


    const init = async () => {
        try {
            setLoader(true)
            const dropdownData = await getDropdowns(selectedTab?.key);
            await getMappingList(0, 50, dropdownData)
            setDropdowns((prev) => ({ ...prev, ...dropdownData }))
        }
        catch (err) {
            console.error(err)
        }
        finally {
            setLoader(false)
        }
    }


    const getMappingList = async (page = 0, pageSize = currPageSize, dropdown = dropdowns, reqObj = {}) => {
        try {
            setLoader(true)
            const url = selectedTab?.key != 'logs' ?
                `${endpoint?.[selectedTab?.key]?.search}?offset=${page}&limit=${pageSize}` :
                `${endpoint.getEmployeeDetailLogs}?offset=${page}&limit=${pageSize}&operationType=DEPARTMENT_MAPPING_OPERATION,REGION_MAPPING_OPERATION,JOBTITLE_MAPPING_OPERATION`
            const data = selectedTab?.key != 'logs' ?
                await fetchAllPostPromisedData(url, reqObj) :
                await fetchAllPromisedData(url, true)

            if (data?.code == 200) {
                const responseListKey = responseListKeyMapping?.[selectedTab?.key]
                const rowList = processRowList(data?.data?.[responseListKey] ?? [], dropdown?.[selectedTab?.key])
                setRows(rowList.map((item, index) => ({ ...item, srNo: index + 1 })))
                setRowCount(data?.data?.totalRecords)
                setCurrentPage(page)
                setCurrentPageSize(pageSize)
            }
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoader(false)
        }
    }
    const createUpdateHandler = async (rowForm) => {
        try {
            setLoader(true);
            const reqObj = {
                ...rowForm,
            }
            let url = `${endpoint?.[selectedTab?.key]?.create}`
            let method = 'post';

            if (!rowForm?.isNew) {
                url = `${endpoint?.[selectedTab?.key]?.update}/${reqObj?.id}`;
                method = 'put'
            }
            const resp = await fetchAllPostPromisedData(url, createReqObj(reqObj), method);
            if (resp?.code === 200) {
                getMappingList();
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }
        finally {
            setLoader(false)
        }
    }
    const deleteHandler = async (rowData) => {
        try {
            setLoader(true);
            const url = `${endpoint?.[selectedTab?.key]?.delete}/${rowData?.id}`;
            const resp = await fetchDeletePromisedData(url);
            if (resp?.code === 200) {
                getMappingList()
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }
        finally {
            setLoader(false)
        }
    };
    const searchInputHandler = (selectedField, inputValue) => {
        getMappingList(0, currPageSize, dropdowns, { [selectedField]: inputValue })
    }

    const crossInputHandler = () => {
        getMappingList()
    }

    return (
        <div className="" style={{ width: '70%', overflowY: 'auto', flexGrow: 1 }}>
            <Card className='ml-0'>
                <CardBody>
                    <div className='d-flex justify-content-between m-2'>
                        <div className='large-text color-grey-80'>{selectedTab?.label}</div>
                        {selectedTab?.key != 'logs' && <div className='d-flex align-items-start'>
                            <AMultiFieldSearchInput
                                key={selectedTab?.key}
                                options={searchInputOptions}
                                searchHandler={searchInputHandler}
                                crossHandler={crossInputHandler}
                            //isLoading={isLoading}
                            />
                            {userPermissions?.includes("C") && <AButton
                                variant='primary_filled'
                                onClick={() => ref.current.addNewRow()}
                                size='xs'
                            >
                                + Create new
                            </AButton>}
                        </div>}
                    </div>
                    <div className='mt-3' style={{ border: '1px solid #E2E2E2' }}>

                        <ListComponent
                            selectedTab={selectedTab}
                            rows={rows}
                            setRows={setRows}
                            ref={ref}
                            dropdowns={dropdowns}
                            createUpdateHandler={createUpdateHandler}
                            deleteHandler={deleteHandler}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            loader={loader}
                            setLoader={setLoader}
                            getMappingList={getMappingList}
                            rowCount={rowCount ?? 0}
                            currPageSize={currPageSize}
                            setCurrentPageSize={setCurrentPageSize}
                            setRowForm={setRowForm}
                            rowForm={rowForm}
                            userPermissions={userPermissions}
                        />

                    </div>
                    {rows.length > 0 && getAuditDetails(rows[0].updatedBy, rows[0].updatedOn)}
                </CardBody>

            </Card>
        </div>
    )
}
export default MappingListing;